// extracted by mini-css-extract-plugin
export var button = "_c2-0";
export var icon = "_c2-1";